/* achilles-collection-pin.js
 * ?pin=<product_id> on a collection URL floats that product to position #1 INSTANTLY and
 * turns its image into an auto-advancing slideshow (2s/slide + progress bar) that cycles the
 * product's Shopify media plus its ad photos (window.ACH_PIN_MAP). No effect without the param. */
(function () {
  var pin = new URLSearchParams(window.location.search).get('pin');
  if (!pin || !/^\d+$/.test(pin)) return;

  var SEL = '.grid__item[data-product-id="' + pin + '"]';
  var MAP = (window.ACH_PIN_MAP && window.ACH_PIN_MAP[pin]) || null;
  var grid, placed = false, busy = false, enhanced = false, slideTimer = null;

  injectStyles();

  // ---------- helpers ----------
  function firstProductChild(g) {
    var k = g.children;
    for (var i = 0; i < k.length; i++) if (k[i].matches && k[i].matches('.grid__item[data-product-id]')) return k[i];
    return g.firstElementChild;
  }
  function sizeUrl(u) { return u.replace(/(\.(?:jpg|jpeg|png|webp))(\?[^#]*)?($|#)/i, function (_, ext, q) { var base = ext + (q ? q : '?'); return /width=/.test(base) ? base : base + (q ? '&' : '') + 'width=600'; }); }
  function dedupe(a) { var seen = {}, o = []; a.forEach(function (u) { var key = (u.split('?')[0].split('/').pop() || u); if (!seen[key]) { seen[key] = 1; o.push(u); } }); return o; }
  function reviveImages(root) { var olds = root.querySelectorAll('img'); for (var i = 0; i < olds.length; i++) { var old = olds[i], f = document.createElement('img'); for (var a = 0; a < old.attributes.length; a++) f.setAttribute(old.attributes[a].name, old.attributes[a].value); f.setAttribute('loading', 'eager'); old.parentNode.replaceChild(f, old); } }

  // ---------- slideshow ----------
  function buildSlideshow(urls) {
    var ss = document.createElement('div'); ss.className = 'ach-pin-ss';
    var track = document.createElement('div'); track.className = 'ach-pin-ss__track';
    urls.forEach(function (u) {
      var s = document.createElement('div'); s.className = 'ach-pin-ss__slide';
      var im = document.createElement('img'); im.loading = 'eager'; im.alt = '';
      // a broken image must never show a broken icon: drop that slide; if none survive, drop the overlay
      im.onerror = function () { s.remove(); if (!track.querySelector('.ach-pin-ss__slide')) ss.remove(); };
      im.src = u; s.appendChild(im); track.appendChild(s);
    });
    var bar = document.createElement('div'); bar.className = 'ach-pin-ss__bar'; var fill = document.createElement('i'); bar.appendChild(fill);
    ss.appendChild(track); ss.appendChild(bar);
    return { ss: ss, track: track, fill: fill, n: urls.length };
  }
  function runSlideshow(r) {
    if (slideTimer) { clearInterval(slideTimer); slideTimer = null; }
    var live = function () { return r.track.querySelectorAll('.ach-pin-ss__slide').length; };
    if (live() <= 1) { r.fill.style.width = '100%'; return; }
    var i = 0;
    function cycle() { r.fill.style.transition = 'none'; r.fill.style.width = '0%'; void r.fill.offsetWidth; r.fill.style.transition = 'width 2s linear'; r.fill.style.width = '100%'; }
    cycle();
    slideTimer = setInterval(function () { var n = live(); if (n <= 1) return; i = (i + 1) % n; r.track.style.transform = 'translateX(-' + (i * 100) + '%)'; cycle(); }, 2000);
  }
  function mountSlideshow(mask, urls, startWith) {
    var old = mask.querySelector('.ach-pin-ss'); if (old) old.remove();
    var list = startWith ? dedupe(startWith.concat(urls)) : dedupe(urls);
    var refs = buildSlideshow(list); mask.appendChild(refs.ss); runSlideshow(refs); return refs;
  }

  // gather product media (async) and merge into an existing slideshow
  function collectAndPlay(mask, handle) {
    var ad = (MAP && MAP.a) ? MAP.a.slice() : [];
    // instant play with ad photos if we have them
    if (ad.length) mountSlideshow(mask, ad);
    fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : Promise.reject(); }).then(function (p) {
      var media = p.media || p.images || [], urls = [];
      media.forEach(function (m) { var s = (typeof m === 'string') ? m : (m.src || (m.preview_image && m.preview_image.src)); if (s) { if (s.indexOf('//') === 0) s = 'https:' + s; urls.push(sizeUrl(s)); } });
      var full = dedupe(ad.concat(urls));
      if (full.length) mountSlideshow(mask, full);
    }).catch(function () { if (!ad.length) { /* leave card's own image */ } });
  }

  function enhanceCard(card) {
    if (enhanced) return; var mask = card.querySelector('.grid-product__image-mask'); if (!mask) return;
    enhanced = true; card.classList.add('ach-pin-enhanced');
    reviveImages(mask); // force the card's own product image to load as a fallback under the slideshow
    var handle = card.getAttribute('data-product-handle') || (MAP && MAP.h);
    if (handle) collectAndPlay(mask, handle);
  }

  // ---------- instant loader card (later-batch products) ----------
  function insertLoader() {
    var proto = grid.querySelector('.grid__item[data-product-id]'); if (!proto || !MAP) return null;
    var maskH = 0; var pm = proto.querySelector('.grid-product__image-mask'); if (pm) maskH = pm.offsetHeight;
    var el = document.createElement('div');
    el.className = proto.className + ' ach-pin-loader';
    el.setAttribute('data-product-id', pin); el.setAttribute('data-product-handle', MAP.h); el.setAttribute('data-pinned', '1'); el.setAttribute('data-pin-loader', '1');
    var a = document.createElement('a'); a.className = 'ach-pin-loader__link'; a.setAttribute('href', '/products/' + encodeURIComponent(MAP.h));
    var mask = document.createElement('div'); mask.className = 'grid-product__image-mask ach-pin-loader__mask'; if (maskH) mask.style.height = maskH + 'px';
    var title = document.createElement('div'); title.className = 'ach-pin-loader__title'; title.textContent = MAP.t || '';
    a.appendChild(mask); a.appendChild(title); el.appendChild(a);
    grid.insertBefore(el, firstProductChild(grid));
    collectAndPlay(mask, MAP.h); // slideshow starts instantly with ad photos
    return el;
  }

  // ---------- placement ----------
  function moveExistingToFront() {
    if (placed) return true; var card = grid.querySelector(SEL); if (!card) return false;
    busy = true; card.setAttribute('data-pinned', '1'); grid.insertBefore(card, firstProductChild(grid)); placed = true; busy = false;
    dedupe; enhanceCard(card); return true;
  }
  function removeDupes() { var all = grid.querySelectorAll(SEL); for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-pinned') !== '1') all[i].remove(); }

  function fetchCard(page, loader) {
    if (placed || page > 15) return;
    fetch(window.location.pathname + '?page=' + page, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        if (placed) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector(SEL);
        if (card) {
          busy = true;
          var node = document.importNode(card, true); node.setAttribute('data-pinned', '1'); reviveImages(node);
          if (loader && loader.parentNode) loader.parentNode.replaceChild(node, loader); else grid.insertBefore(node, firstProductChild(grid));
          placed = true; busy = false; removeDupes(); enhanceCard(node);
        } else if (doc.querySelector('.grid--uniform .grid__item[data-product-id]')) {
          fetchCard(page + 1, loader);
        }
      })
      .catch(function () {});
  }

  function init() {
    grid = document.querySelector('.grid--uniform'); if (!grid) return;
    if (!moveExistingToFront()) { var loader = insertLoader(); fetchCard(2, loader); }
    var mo = new MutationObserver(function () { if (busy) return; if (placed) removeDupes(); else moveExistingToFront(); });
    mo.observe(grid, { childList: true });
  }

  function injectStyles() {
    if (document.getElementById('ach-pin-style')) return;
    var css = '.ach-pin-ss{position:absolute;inset:0;z-index:2;overflow:hidden;pointer-events:none;background:#f3f1ee}'
      + '.ach-pin-ss__track{display:flex;height:100%;width:100%;transition:transform .55s cubic-bezier(.45,0,.15,1);will-change:transform}'
      + '.ach-pin-ss__slide{flex:0 0 100%;height:100%}'
      + '.ach-pin-ss__slide img{width:100%;height:100%;object-fit:cover;display:block}'
      + '.ach-pin-ss__bar{position:absolute;left:0;right:0;bottom:0;height:3px;background:rgba(0,0,0,.1);z-index:3}'
      + '.ach-pin-ss__bar i{display:block;height:100%;width:0;background:#111}'
      + '.ach-pin-loader__link{display:block;color:inherit;text-decoration:none}'
      + '.ach-pin-loader__mask{position:relative;overflow:hidden;background:#f3f1ee;min-height:60vw}'
      + '.ach-pin-loader__title{padding:12px 4px 4px;font-size:13px;letter-spacing:.02em;text-transform:uppercase;opacity:.85}';
    var s = document.createElement('style'); s.id = 'ach-pin-style'; s.textContent = css; document.head.appendChild(s);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
